import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { selectTree } from '../../redux/context/selectors';
import { consolePathFor } from '../../redux/context/treeUtils';
import { useSandboxOrganisation } from '../hooks/useSandboxOrganisation';
import ResourceShell from './resource/ResourceShell';
import ResourceIcon from './resource/ResourceIcon';

const platformMenu = [
  { 
    key: 'overview', 
    name: 'Overview', 
    path: '/admin', 
    icon: <ResourceIcon name="dashboard" /> 
  }, { 
    key: 'organisations', 
    name: 'Organisations', 
    path: '/admin/organisations', 
    icon: <ResourceIcon name="building" /> 
  }, { 
    key: 'access', 
    name: 'IAM & Access', 
    path: '/admin/access', 
    icon: <ResourceIcon name="users" /> 
  }, { 
    key: 'audit', 
    name: 'Audit Logs', 
    path: '/admin/audit', 
    icon: <ResourceIcon name="audit" /> 
  }
];

export default function PlatformLayout() {
  const navigate = useNavigate();
  const tree = useSelector(selectTree);
  const sandbox = useSandboxOrganisation();
  const ownRoot = (tree ?? []).find((n: any) => n.has_console);
  const ownPath = ownRoot ? consolePathFor(ownRoot) : null;
  const backLabel = ownPath ? 'Open my organisation' : 'Back to workspace';
  const goBack = () => navigate(ownPath || '/');
  const hasBack = Boolean(ownPath) || (tree ?? []).length > 0;
  const backItems = hasBack ? [{
    key: 'workspace',
    icon: <ArrowLeft size={16} />,
    label: backLabel,
    onClick: goBack
  }] : [];

  return (
    <ResourceShell
      platform
      menu={platformMenu}
      sidebarLabel="ADMINISTRATION"
      homePath="/admin"
      userMenu={{ hidePlatformLink: true, extraItems: backItems }}
      topbarExtras={sandbox && (
        <button
          className="sw-button"
          onClick={() => navigate(`/org/${sandbox.id}`)}
        >Sandbox</button>
      )}
    />
  );
}
